import { useSession } from '~hooks/queries/auth/query';

export default function useSuperUserHook() {
  const { data: session } = useSession();

  return {
    data: session,
    status: session == null ? 'notAuthenticated' : 'authenticated',
  };
}
